import { RunArchiveAddonImportsDocument } from '@/api/queries';
import { RunArchiveImportsInput } from '@/models/gen/graphql';
import graphApi from '@/api';

const [, runRefetchRunArchiveImports] = graphApi(RunArchiveAddonImportsDocument);

const runArchiveAddonImports = async (importIds: string[]) => {
  const input: RunArchiveImportsInput = {
    importIds,
  };
  const res = await runRefetchRunArchiveImports({ input });
  return res?.runArchiveImports;
};

export default runArchiveAddonImports;
